import { BlogError } from '@/exceptions/blog/blog.enum';
import { blogService } from '@/services/blog.service';
import { notificationService } from '@/services/notification.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useDeleteBlog = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (blogId: number) =>
			await blogService.deleteBlog(blogId),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['blog'] });
			notificationService.success("blog deleted Succesful");

		},

		onError: () => {
			throw new Error(BlogError.DELETE_ERROR);
		},
	});
};

export default useDeleteBlog;